export function getLocaleToUse(availableLocales: string[], userLocales: string[]): string {
    const fallbackLocale = "en";
    for (const userLocale of userLocales) {
        if (availableLocales.includes(userLocale)) {
            return userLocale;
        }
    }

    return fallbackLocale;
}

export function determineTranslation(translations: { [key:string]:{} }): {} {
    let userLocales = window.navigator.languages;

    if (window.globalSettings && window.globalSettings.twoLetterLocaleFallBacks && window.globalSettings.twoLetterLocaleFallBacks.length) {
        userLocales = window.globalSettings.twoLetterLocaleFallBacks;
    }

    for (const locale of userLocales) {
        if (translations[locale]) {
            return translations[locale];
        }
    }
    
    return translations.en;
}

export function addTranslation(translations: { [key:string]: { [key:string]: string } }, locale: string, localValues: {name: string; value: string}[]): void {
    if(!translations[locale]){
        translations[locale] = {};
    }

    localValues.forEach(localValue => {
        translations[locale][localValue.name] = localValue.value;
    });
}